import React, { FC } from 'react';

import { Field } from 'formik';

import { IFormField } from './types';

export const FormField: FC<IFormField> = props => <Field {...props} />;
